import { useContext } from 'use-context-selector';
import { ToastNotificationsContext } from 'Contexts/ToastNotificationsContext';

export default function useToastNotifications() {
  return useContext(ToastNotificationsContext);
}
